// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2VDT0","error":"Textarea_error__VaCgT","readonly":"Textarea_readonly__25k8A","disabled":"Textarea_disabled__1Ff2M"};